import React from "react";
import Modal from "react-modal";

import { ReactComponent as Close } from "../../../../assets/images/close.svg";

import "./ConfirmModal.scss";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF",
    maxWidth: "500px",
    width: "90%",
  },
};

export interface ConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  customerName: string;
  action?: "approve" | "reject";
}

export function ConfirmModal(props: ConfirmModalProps) {
  const { isOpen, onConfirm, onCancel, customerName, action = "approve" } = props;

  const title = action === "approve" ? "Confirm Order Approval" : "Confirm Order Rejection";
  const message = action === "approve"
    ? `Are you sure you want to approve this order for`
    : `Are you sure you want to reject this order for`;

  return (
    <Modal isOpen={isOpen} onRequestClose={onCancel} style={modalStyles}>
      <div className="confirm-modal-component">
        <Close className="close-button" onClick={onCancel} />

        <div className="title">{title}</div>

        <div className="message">
          {message} <strong>{customerName}</strong>?
        </div>

        <div className="buttons-container">
          <button className="button cancel-button" onClick={onCancel}>
            Cancel
          </button>
          <button className="button confirm-button" onClick={onConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
}
